export default {
  apiPoint: 'static'
};
